import React from 'react'
import Navbar from '../../Components/Navbar'
import ProductHeader from '../../Components/ProductHeader'
import CustmrFocus from '../../Components/CustmrFocus'
import Business from '../../Components/Business'
import Footer from '../../Components/Footer'

const CustomerFocus = () => {
  return (
    <div>
       <Navbar/>
      <ProductHeader/>
      <CustmrFocus/>
      <Business/>
      <Footer/>
    </div>
  )
}

export default CustomerFocus
